import { httpBackOfficeUtil } from './httpBackOfficeUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'
import { getData } from '../../utils/common';
export const config = {
	getAppCfg,
	getLanguages,
	getDevices
}

async function getAppCfg({
	app_id,
	use_cname = false,
	cname
} = {}) {
	try {
		var appId = await getData("APP_ID");
		if(!app_id) app_id = appId;
		
		var queryParams = {}
		if (use_cname) {
			queryParams.cloud_name = cname;
		}else {
			queryParams.platform_app_id = app_id;
		}
		let response = await httpBackOfficeUtil.get({
			resourcePath: '/v2/applications',
			queryParams: queryParams,
			logOutIfSessionInvalid: false,
            isBackend: false
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getAppCfg: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getLanguages({ unauthorize = true }) {
	try {
		let response = await httpBackOfficeUtil.get({
			resourcePath: '/v2/languages',
			logOutIfSessionInvalid: false,
            isBackend: false
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getLanguages: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getDevices({
	custom_fields,
	include_custom_fields = true,
	in_warehouse = true,
	product_id
},{}) {
	try {
		let response = await httpBackOfficeUtil.get({
			resourcePath: '/v2/devices',
			queryParams:{
				include_custom_fields,
				custom_fields,
				in_warehouse,
				product_id,
			},
            isBackend: true
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getDevices: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}